export class Settings {
    logoSrc: string;
    code: string;
    supportEmail: string;
    landingPageUri: string;
}
